import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Checkbox } from '@/components/ui/checkbox';
import { CommandGroup, CommandItem } from '@/components/ui/command';
import { TASK_PRIORITIES } from '../../../constants';
import { useFilters, useResources } from '../../../hooks';

const filterValue = (value) => (value === null ? 'null' : value);

const PriorityList = () => {
  const { activeFilters, toggleFilter } = useFilters();
  const { priorities } = useResources();

  const isSelected = (value) => activeFilters.priorities.includes(value);

  return (
    <CommandGroup>
      {priorities.map((priority) => {
        const { color, icon } = TASK_PRIORITIES[priority.value || 'none'];
        const value = filterValue(priority.value);

        return (
          <CommandItem
            key={value}
            onSelect={() => toggleFilter({ type: 'priorities', value })}
            value={priority.label}
          >
            <Checkbox checked={isSelected(value)} />
            <FontAwesomeIcon className={color} icon={icon} />
            <span className="truncate">{priority.label}</span>
          </CommandItem>
        );
      })}
    </CommandGroup>
  );
};

export default PriorityList;
